import { Injectable } from '@angular/core';
import { Api } from '../api/api';
import { User } from '../user/user';

@Injectable()
export class Notes {
  list: any;

  constructor(public api:Api, public user:User) { 

  }

  get(params?: any) {
    return this.api.get('index.php/project/notes', params);
  }

  delete(params?: any) {
    return this.api.post('index.php/project/notes/delete', params);
  }

  post(params?: any) {
    params.created_by = this.user.data.employee_id;
    return this.api.post('index.php/project/notes', params);
  }

  category(params?: any) {
    return this.api.get('index.php/project/notes/category', params);
  }

}


// WEBPACK FOOTER //
// ./src/providers/project_providers/notes/notes.ts